import React, { useEffect, useState } from 'react';
import { useTournamentStore } from '../../store/tournamentStore';
import infoIcon from '../../assets/images/info.svg';
import pcCaddie from '../../assets/images/pcc.svg';
import Gender from './gender';
import { useGlobalStore } from '../../store/globalStore';

interface TournamentInformationProps {
  fullview?: boolean;
}

const TournamentInformation: React.FC<TournamentInformationProps> = ({
  fullview = false,
}) => {
  const searchParams = new URLSearchParams(window.location.search);
  const deadline = searchParams.get('deadline');
  const [tournament_deadline, setTournamentDeadline] = useState('');

  useEffect(() => {
    if (deadline) {
      setTournamentDeadline(deadline);
    }
  }, [deadline]);

  const information = useTournamentStore((state) => state.information);
  const selectedPlayers = useTournamentStore((state) => state.selectedPlayers);
  const selectedErsatzspieler = useTournamentStore(
    (state) => state.selectedErsatzspieler,
  );

  const selectedEinzelspieler = useTournamentStore(
    (state) => state.selectedEinzelspieler,
  );

  const selectedEinzelersatzspieler = useTournamentStore(
    (state) => state.selectedEinzelersatzspieler,
  );

  const sortedPlayers = useTournamentStore((state) => state.sortedPlayers);
  const sortedEinzelspieler = useTournamentStore(
    (state) => state.sortedEinzelspieler,
  );
  const sortedErsatzspielers = useTournamentStore(
    (state) => state.sortedErsatzspielers,
  );
  const companions = useTournamentStore((state) => state.companions);
  const capitan = useTournamentStore((state) => state.capitan);
  const melder = useTournamentStore((state) => state.melder);
  const isLoading = useGlobalStore((state) => state.isLoading);

  return (
    <div className={`${fullview && 'zigzag'} ${isLoading ? 'opacity-50' : ''}`}>
      <div
        id="tournamentInformation"
        className={`grid cursor-default bg-white overflow-hidden gap-1 border p-4 rounded-md relative leading-6 ${fullview ? 'fullview-class rounded-none' : ''}`}
      >
        <img
          src={infoIcon}
          alt="infoIcon"
          className="absolute md:inline-block hidden duration-300 right-4 -top-10"
        />

        <img
          src={pcCaddie}
          alt="pccaddie online"
          className="h-10 mb-10 print-only"
        />

        <div className="my-5 print-only text-xl font-medium">
          ℹ️ Turnierinformationen
        </div>

        <div className="flex  gap-4">
          <div className="w-36 font-medium">🏆 Turnier</div>
          <div>{information.title}</div>
        </div>
        <div className="flex gap-4">
          <div className="w-36 font-medium">📅 Datum</div>
          <div>{information.startDate}</div>
        </div>
        <div className="flex gap-4">
          <div className="w-36 font-medium">⏰ Meldeschluss</div>
          <div>
            {tournament_deadline
              ? tournament_deadline
              : information.registrationEnd}
          </div>
        </div>
        <div className="flex gap-4">
          <div className="w-36 font-medium">🏅 Wettspielart</div>
          {information.matchType && (
            <div>
              {information.matchType === 'single'
                ? 'Zählspiel-Einzel'
                : 'Zählspiel-Vierer'}
            </div>
          )}
        </div>
        <div className="flex gap-4">
          <div className="w-36 font-medium">👥 Anzahl Spieler</div>
          <div>
            {information.numberOfPlayers}
            {information.numberOfSubstitute
              ? ` + (${information.numberOfSubstitute} Ersatzspieler)`
              : ''}
          </div>
        </div>

        {information.gender !== 'N' && (
          <div className="flex gap-4">
            <div className="w-36 font-medium">⚧️ Geschlecht</div>

            {information.gender && (
              <div className="flex gap-1">
                {information.gender === 'MW' ? (
                  <>
                    <Gender gender="M" />
                    <Gender gender="W" />
                  </>
                ) : (
                  <Gender gender={information.gender} />
                )}
              </div>
            )}
          </div>
        )}

        {fullview && (
          <>
            <div className="my-5 text-lg flex items-center justify-between gap-5 font-medium">
              🏌️ Spieler (
              {selectedPlayers.filter((player) => player !== null).length}/
              {information.numberOfPlayers})
            </div>
            {sortedPlayers.map((item, index) => (
              <div key={index} className="flex items-center gap-4">
                <div className="px-2 py-0.5 min-w-[160px] flex gap-2 items-center sm:min-w-[230px] font-medium">
                  {information.requireTee && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 19.0001V17.0001H17V19.0001H15C14.5 19.0001 14 19.2001 13.6 19.6001C13.2 20.0001 13 20.5001 13 21.0001V22.0001H11V21.0001C11 20.5001 10.8 20.0001 10.4 19.6001C10 19.2001 9.5 19.0001 9 19.0001H7ZM11 6.0001C11 5.7001 11.1 5.5001 11.3 5.3001C11.5 5.1001 11.7 5.0001 12 5.0001C12.3 5.0001 12.5 5.1001 12.7 5.3001C12.9 5.5001 13 5.7001 13 6.0001C13 6.3001 12.9 6.5001 12.7 6.7001C12.5 6.9001 12.3 7.0001 12 7.0001C11.7 7.0001 11.5 6.9001 11.3 6.7001C11.1 6.5001 11 6.3001 11 6.0001ZM13 8.0001C13 7.7001 13.1 7.5001 13.3 7.3001C13.5 7.1001 13.7 7.0001 14 7.0001C14.3 7.0001 14.5 7.1001 14.7 7.3001C14.9 7.5001 15 7.7001 15 8.0001C15 8.3001 14.9 8.5001 14.7 8.7001C14.5 8.9001 14.3 9.0001 14 9.0001C13.7 9.0001 13.5 8.9001 13.3 8.7001C13.1 8.5001 13 8.3001 13 8.0001ZM9 8.0001C9 7.7001 9.1 7.5001 9.3 7.3001C9.5 7.1001 9.7 7.0001 10 7.0001C10.3 7.0001 10.5 7.1001 10.7 7.3001C10.9 7.5001 11 7.7001 11 8.0001C11 8.3001 10.9 8.5001 10.7 8.7001C10.5 8.9001 10.3 9.0001 10 9.0001C9.7 9.0001 9.5 8.9001 9.3 8.7001C9.1 8.5001 9 8.3001 9 8.0001ZM16.9 4.1001C15.5 2.7001 13.9 2.1001 12 2.1001C10.1 2.1001 8.4 2.8001 7.1 4.1001C5.8 5.4001 5 7.1001 5 9.0001C5 10.9001 5.7 12.6001 7 13.9001C8.3 15.2001 10 15.9001 11.9 15.9001C13.8 15.9001 15.5 15.2001 16.8 13.9001C18.1 12.6001 18.8 10.9001 18.8 9.0001C18.8 7.1001 18.3 5.4001 16.9 4.1001ZM15.5 12.5001C14.5 13.5001 13.3 14.0001 12 14.0001C10.7 14.0001 9.4 13.5001 8.5 12.5001C7.6 11.5001 7 10.4001 7 9.0001C7 7.6001 7.5 6.4001 8.5 5.5001C9.5 4.6001 10.6 4.0001 12 4.0001C13.4 4.0001 14.6 4.5001 15.5 5.5001C16.4 6.5001 17 7.6001 17 9.0001C17 10.4001 16.5 11.6001 15.5 12.5001Z"
                        fill={
                          selectedPlayers[item]?.color === 'yellow'
                            ? 'orange'
                            : selectedPlayers[item]?.color || '#cccccc'
                        }
                      />
                    </svg>
                  )}

                  {information.matchType === 'team' && (index + 1) % 2 === 0
                    ? `↳ mit ${index + 1}. Spieler`
                    : `${index + 1}. Spieler`}
                </div>
                <div>
                  {selectedPlayers[item] ? (
                    <div className=" flex items-center gap-2">
                      {selectedPlayers[item].gender && (
                        <Gender
                          gender={selectedPlayers[item].gender as 'M' | 'W'}
                        />
                      )}
                      <p className="font-bold min-w-[220px]">
                        {selectedPlayers[item]?.title}{' '}
                        {selectedPlayers[item]?.name}{' '}
                        {selectedPlayers[item]?.lastName}
                      </p>
                      <span className=" ml-5 hidden sm:inline-block">
                        HCP : {selectedPlayers[item]?.hcp ?? '0.0'}
                        <small>
                          {selectedPlayers[item]?.pending &&
                            ' ( ⚠️ Nicht aktualisiert ) '}
                        </small>
                      </span>
                    </div>
                  ) : (
                    <div>⚠️ Spieler nicht ausgewählt</div>
                  )}
                </div>
              </div>
            ))}
            <div className="my-5 text-lg gap-5 font-medium flex items-center justify-between">
              🔄 Ersatzspieler (
              {selectedErsatzspieler.filter((player) => player !== null).length}
              /{information.numberOfSubstitute})
            </div>
            {sortedErsatzspielers.map((item, index) => (
              <div key={index} className="flex items-center gap-4">
                <div className="px-2 flex gap-2 items-center py-0.5 min-w-[160px] sm:min-w-[230px] font-medium">
                  {information.requireTee && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 19.0001V17.0001H17V19.0001H15C14.5 19.0001 14 19.2001 13.6 19.6001C13.2 20.0001 13 20.5001 13 21.0001V22.0001H11V21.0001C11 20.5001 10.8 20.0001 10.4 19.6001C10 19.2001 9.5 19.0001 9 19.0001H7ZM11 6.0001C11 5.7001 11.1 5.5001 11.3 5.3001C11.5 5.1001 11.7 5.0001 12 5.0001C12.3 5.0001 12.5 5.1001 12.7 5.3001C12.9 5.5001 13 5.7001 13 6.0001C13 6.3001 12.9 6.5001 12.7 6.7001C12.5 6.9001 12.3 7.0001 12 7.0001C11.7 7.0001 11.5 6.9001 11.3 6.7001C11.1 6.5001 11 6.3001 11 6.0001ZM13 8.0001C13 7.7001 13.1 7.5001 13.3 7.3001C13.5 7.1001 13.7 7.0001 14 7.0001C14.3 7.0001 14.5 7.1001 14.7 7.3001C14.9 7.5001 15 7.7001 15 8.0001C15 8.3001 14.9 8.5001 14.7 8.7001C14.5 8.9001 14.3 9.0001 14 9.0001C13.7 9.0001 13.5 8.9001 13.3 8.7001C13.1 8.5001 13 8.3001 13 8.0001ZM9 8.0001C9 7.7001 9.1 7.5001 9.3 7.3001C9.5 7.1001 9.7 7.0001 10 7.0001C10.3 7.0001 10.5 7.1001 10.7 7.3001C10.9 7.5001 11 7.7001 11 8.0001C11 8.3001 10.9 8.5001 10.7 8.7001C10.5 8.9001 10.3 9.0001 10 9.0001C9.7 9.0001 9.5 8.9001 9.3 8.7001C9.1 8.5001 9 8.3001 9 8.0001ZM16.9 4.1001C15.5 2.7001 13.9 2.1001 12 2.1001C10.1 2.1001 8.4 2.8001 7.1 4.1001C5.8 5.4001 5 7.1001 5 9.0001C5 10.9001 5.7 12.6001 7 13.9001C8.3 15.2001 10 15.9001 11.9 15.9001C13.8 15.9001 15.5 15.2001 16.8 13.9001C18.1 12.6001 18.8 10.9001 18.8 9.0001C18.8 7.1001 18.3 5.4001 16.9 4.1001ZM15.5 12.5001C14.5 13.5001 13.3 14.0001 12 14.0001C10.7 14.0001 9.4 13.5001 8.5 12.5001C7.6 11.5001 7 10.4001 7 9.0001C7 7.6001 7.5 6.4001 8.5 5.5001C9.5 4.6001 10.6 4.0001 12 4.0001C13.4 4.0001 14.6 4.5001 15.5 5.5001C16.4 6.5001 17 7.6001 17 9.0001C17 10.4001 16.5 11.6001 15.5 12.5001Z"
                        fill={
                          selectedErsatzspieler[item]?.color === 'yellow'
                            ? 'orange'
                            : selectedErsatzspieler[item]?.color || '#cccccc'
                        }
                      />
                    </svg>
                  )}
                  {index + 1}. Ersatzspieler
                </div>
                <div>
                  {selectedErsatzspieler[item] ? (
                    <div className="flex items-center gap-2">
                      {selectedErsatzspieler[item].gender && (
                        <Gender
                          gender={
                            selectedErsatzspieler[item].gender as 'M' | 'W'
                          }
                        />
                      )}

                      <p className="font-bold min-w-[220px]">
                        {selectedErsatzspieler[item]?.title}{' '}
                        {selectedErsatzspieler[item]?.name}{' '}
                        {selectedErsatzspieler[item]?.lastName}
                      </p>
                      <span className=" ml-5 hidden sm:inline-block">
                        HCP : {selectedErsatzspieler[item]?.hcp ?? '0.0'}
                        <small>
                          {selectedErsatzspieler[item]?.pending &&
                            ' ( ⚠️ Nicht aktualisiert ) '}
                        </small>
                      </span>
                    </div>
                  ) : (
                    <div>-</div>
                  )}
                </div>
              </div>
            ))}
            {information.requireCompanion && (
              <>
                <div className="h-0.5 bg-gray-200  mt-5"></div>
                <div>
                  <div className="my-2 text-lg font-medium">👥 Begleiter</div>
                  {Array.from({
                    length: Math.max(
                      1,
                      Math.ceil(
                        (selectedPlayers.filter((p) => p !== null).length +
                          selectedErsatzspieler.filter((p) => p !== null)
                            .length) /
                          3,
                      ),
                    ),
                  }).map((_, index) => (
                    <div
                      className={`px-2 flex gap-2 items-center min-w-[160px] sm:min-w-[230px] font-medium`}
                      key={index}
                    >
                      <div className="px-2 flex gap-2 items-center py-0.5 min-w-[160px] sm:min-w-[230px] font-medium">
                        Begleiter {index + 1}
                      </div>
                      <div className="pr-2 py-1 max-w-[330px]">
                        {companions[index] ? (
                          companions[index].trim()
                        ) : (
                          <div>⚠️ Kein Begleiter ausgewählt</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {information.individualAllowed && (
              <>
                <div className="h-0.5 bg-gray-200  mt-5"></div>
                <div className="my-5 text-xl items-center justify-between gap-5 font-bold">
                  ⛳ Meldung Einzelspieler für 2. Runde
                </div>
                <div className="text-lg items-center justify-between gap-5 font-medium">
                  🏌️ Einzelspieler (
                  {
                    selectedEinzelspieler.filter((player) => player !== null)
                      .length
                  }
                  /{information.numberOfPlayers})
                </div>
                {sortedEinzelspieler.map((item, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <div className="px-2 py-0.5 min-w-[160px] flex gap-2 items-center sm:min-w-[230px] font-medium">
                      {index + 1}. Einzelspieler
                    </div>
                    <div>
                      {selectedEinzelspieler[item] ? (
                        <div className=" flex items-center gap-2">
                          {selectedEinzelspieler[item].gender && (
                            <Gender
                              gender={
                                selectedEinzelspieler[item].gender as 'M' | 'W'
                              }
                            />
                          )}
                          <p className="font-bold min-w-[220px]">
                            {selectedEinzelspieler[item]?.title}{' '}
                            {selectedEinzelspieler[item]?.name}{' '}
                            {selectedEinzelspieler[item]?.lastName}
                          </p>
                          <span className=" ml-5 hidden sm:inline-block">
                            HCP : {selectedEinzelspieler[item]?.hcp ?? '0.0'}
                            <small>
                              {selectedEinzelspieler[item]?.pending &&
                                ' ( ⚠️ Nicht aktualisiert ) '}
                            </small>
                          </span>
                        </div>
                      ) : (
                        <div>⚠️ Spieler nicht ausgewählt</div>
                      )}
                    </div>
                  </div>
                ))}

                <div className="my-5 text-lg gap-5 font-medium flex items-center justify-between">
                  🔄 Ersatzspieler (
                  {
                    selectedErsatzspieler.filter((player) => player !== null)
                      .length
                  }
                  /{information.numberOfSubstitute})
                </div>
                {sortedErsatzspielers.map((item, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <div className="px-2 flex gap-2 items-center py-0.5 min-w-[160px] sm:min-w-[230px] font-medium">
                      {information.requireTee && (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7 19.0001V17.0001H17V19.0001H15C14.5 19.0001 14 19.2001 13.6 19.6001C13.2 20.0001 13 20.5001 13 21.0001V22.0001H11V21.0001C11 20.5001 10.8 20.0001 10.4 19.6001C10 19.2001 9.5 19.0001 9 19.0001H7ZM11 6.0001C11 5.7001 11.1 5.5001 11.3 5.3001C11.5 5.1001 11.7 5.0001 12 5.0001C12.3 5.0001 12.5 5.1001 12.7 5.3001C12.9 5.5001 13 5.7001 13 6.0001C13 6.3001 12.9 6.5001 12.7 6.7001C12.5 6.9001 12.3 7.0001 12 7.0001C11.7 7.0001 11.5 6.9001 11.3 6.7001C11.1 6.5001 11 6.3001 11 6.0001ZM13 8.0001C13 7.7001 13.1 7.5001 13.3 7.3001C13.5 7.1001 13.7 7.0001 14 7.0001C14.3 7.0001 14.5 7.1001 14.7 7.3001C14.9 7.5001 15 7.7001 15 8.0001C15 8.3001 14.9 8.5001 14.7 8.7001C14.5 8.9001 14.3 9.0001 14 9.0001C13.7 9.0001 13.5 8.9001 13.3 8.7001C13.1 8.5001 13 8.3001 13 8.0001ZM9 8.0001C9 7.7001 9.1 7.5001 9.3 7.3001C9.5 7.1001 9.7 7.0001 10 7.0001C10.3 7.0001 10.5 7.1001 10.7 7.3001C10.9 7.5001 11 7.7001 11 8.0001C11 8.3001 10.9 8.5001 10.7 8.7001C10.5 8.9001 10.3 9.0001 10 9.0001C9.7 9.0001 9.5 8.9001 9.3 8.7001C9.1 8.5001 9 8.3001 9 8.0001ZM16.9 4.1001C15.5 2.7001 13.9 2.1001 12 2.1001C10.1 2.1001 8.4 2.8001 7.1 4.1001C5.8 5.4001 5 7.1001 5 9.0001C5 10.9001 5.7 12.6001 7 13.9001C8.3 15.2001 10 15.9001 11.9 15.9001C13.8 15.9001 15.5 15.2001 16.8 13.9001C18.1 12.6001 18.8 10.9001 18.8 9.0001C18.8 7.1001 18.3 5.4001 16.9 4.1001ZM15.5 12.5001C14.5 13.5001 13.3 14.0001 12 14.0001C10.7 14.0001 9.4 13.5001 8.5 12.5001C7.6 11.5001 7 10.4001 7 9.0001C7 7.6001 7.5 6.4001 8.5 5.5001C9.5 4.6001 10.6 4.0001 12 4.0001C13.4 4.0001 14.6 4.5001 15.5 5.5001C16.4 6.5001 17 7.6001 17 9.0001C17 10.4001 16.5 11.6001 15.5 12.5001Z"
                            fill={
                              selectedErsatzspieler[item]?.color === 'yellow'
                                ? 'orange'
                                : selectedErsatzspieler[item]?.color ||
                                  '#cccccc'
                            }
                          />
                        </svg>
                      )}
                      {index + 1}. Ersatzspieler
                    </div>
                    <div>
                      {selectedEinzelersatzspieler[item] ? (
                        <div className="flex items-center gap-2">
                          {selectedEinzelersatzspieler[item].gender && (
                            <Gender
                              gender={
                                selectedEinzelersatzspieler[item].gender as
                                  | 'M'
                                  | 'W'
                              }
                            />
                          )}

                          <p className="font-bold min-w-[220px]">
                            {selectedEinzelersatzspieler[item]?.title}{' '}
                            {selectedEinzelersatzspieler[item]?.name}{' '}
                            {selectedEinzelersatzspieler[item]?.lastName}
                          </p>
                          <span className=" ml-5 hidden sm:inline-block">
                            HCP :{' '}
                            {selectedEinzelersatzspieler[item]?.hcp ?? '0.0'}
                            <small>
                              {selectedEinzelersatzspieler[item]?.pending &&
                                ' ( ⚠️ Nicht aktualisiert ) '}
                            </small>
                          </span>
                        </div>
                      ) : (
                        <div>-</div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
            <div className="h-0.5 bg-gray-200  mt-5"></div>
            <div className="flex gap-4 mt-5 items-center">
              <div className="px-2 py-0.5 text-lg min-w-[130px] sm:min-w-[230px] font-medium">
                👨‍✈️ Kapitän
              </div>
              <div>
                {capitan ? (
                  <div className="font-bold text-md">{capitan}</div>
                ) : (
                  '⚠️ Kapitän nicht ausgewählt'
                )}
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <div className="px-2 py-0.5 text-lg min-w-[130px] sm:min-w-[230px] font-medium">
                📋 Melder
              </div>
              <div>
                {melder ? (
                  <div className="font-bold text-md">{melder}</div>
                ) : (
                  '⚠️ Melder nicht ausgewählt'
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TournamentInformation;
